/**
 * Created by juanramos on 7/6/17.
 */

import { Injectable } from '@angular/core';
import { Loading, LoadingController, Toast, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class MessagePresenter {

  loading: Loading;
  toastInstance: Toast;

  constructor(private toastCtrl: ToastController,
              private loadingCtrl: LoadingController,
              private translate: TranslateService) {}

  presentToast(mensaje: string, duracion:number, posicion: string, button?: boolean, buttonText?: string) {

    if (this.toastInstance) {
      return;
    }
    this.toastInstance = this.toastCtrl.create({
      message: mensaje,
      duration: duracion,
      position: posicion,
      showCloseButton: (button ? button : false),
      closeButtonText: (button ? buttonText : ''),
    });

    this.toastInstance.onDidDismiss(() => {
      this.toastInstance = null;
    });

    this.toastInstance.present();

  }

  presentLoadingCustom(tipo:string, mensaje:string, duracion:number) {
    this.loading = this.loadingCtrl.create({
      spinner: tipo, // crescent
      content:
      '<div class="custom-spinner-container">' +
      ' <div class="custom-spinner-box">' +
      '<span>' + mensaje + '</span> ' +
      ' </div>' +
      '</div>',
      duration: duracion,
    });

    this.loading.onDidDismiss(() => {
    });

    this.loading.present();
  }

  presentNotification(message: any, duracion:number, posicion: string, close: boolean) {
    let toast;
    toast = this.toastCtrl.create({
      message,
      duration: duracion,
      position: posicion,
      showCloseButton: close,
      closeButtonText: this.translate.instant('Chat.close'),
      cssClass: 'toastClass',
    });
    toast.present();
    return toast;
  }

  dismissLoadingCustom() {
    this.loading.dismissAll();
  }
}



// WEBPACK FOOTER //
// ./src/services/message.service.ts